import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M7 7v3h-.5A2.5 2.5 0 0 0 4 12.5v7A2.5 2.5 0 0 0 6.5 22h11a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 0-2.5-2.5H8.2V7a3.8 3.8 0 0 1 7.553-.598c.052.328.316.598.647.598s.604-.27.565-.599A5 5 0 0 0 7 7Zm-1.8 5.5a1.3 1.3 0 0 1 1.3-1.3h11a1.3 1.3 0 0 1 1.3 1.3v7a1.3 1.3 0 0 1-1.3 1.3h-11a1.3 1.3 0 0 1-1.3-1.3v-7Z"
      clip-rule="evenodd"
    />
  </svg>
`;
